import React from "react";
import "../GalleryComponent/GalleryComponentCss/SwachhtaSection.css";

// Import all images
import img1 from "../Images/before1.jpg";
import img2 from "../Images/after1.jpg";
import img3 from "../Images/before2.jpg";
import img4 from "../Images/after2.jpg";
import img5 from "../Images/before3.jpg";
import img6 from "../Images/after3.jpg";
import img7 from "../Images/before4.jpg";
import img8 from "../Images/after4.jpg";
export default function SwachhtaSection() {
  return (
    <section className="swachhta-wrapper">
      <h2 className="swachhta-title">स्वच्छता मिशन</h2>

      <div className="swachhta-grid">
        {/* Row 1 */}
        <div className="swachhta-card">
          <img src={img1} alt="Before Cleaning" className="swachhta-image" />
          <p className="swachhta-label">आधी</p>
        </div>
        <div className="swachhta-card">
          <img src={img2} alt="After Cleaning" className="swachhta-image" />
          <p className="swachhta-label">नंतर</p>
        </div>

        {/* Row 2 */}
        <div className="swachhta-card">
          <img src={img3} alt="Before Cleaning" className="swachhta-image" />
          <p className="swachhta-label">आधी</p>
        </div>
        <div className="swachhta-card">
          <img src={img4} alt="After Cleaning" className="swachhta-image" />
          <p className="swachhta-label">नंतर</p>
        </div>

        {/* Row 3 */}
        <div className="swachhta-card">
          <img src={img5} alt="Before Cleaning" className="swachhta-image" />
          {/* <p className="swachhta-label">आधी</p> */}
        </div>
        <div className="swachhta-card">
          <img src={img6} alt="After Cleaning" className="swachhta-image" />
          {/* <p className="swachhta-label">नंतर</p> */}
        </div>

         {/* Row 3 */}
        <div className="swachhta-card">
          <img src={img7} alt="Before Cleaning" className="swachhta-image" />
          {/* <p className="swachhta-label">आधी</p> */}
        </div>
        <div className="swachhta-card">
          <img src={img8} alt="After Cleaning" className="swachhta-image" />
          {/* <p className="swachhta-label">नंतर</p> */}
        </div>
      </div>
    </section>
  );
}
